import { create } from 'zustand';
import { Item } from 'src/types/api/ListFolderFiles';

interface TableListState {
  selectedFileId: string | null;
  selectedFileName: string | null;
  selectedFolderId: string | null;
  selectedFolder: Item | null;
  selectedFolderName: string | null;
  selectedFile: Item | null;
  
  // Actions
  setSelectedFileId: (id: string | null) => void;
  setSelectedFileName: (name: string | null) => void;
  setSelectedFolderId: (id: string | null) => void;
  setSelectedFolder: (folder: Item | null) => void;
  setSelectedFolderName: (name: string | null) => void;
  setSelectedFile: (file: Item | null) => void;
  
  // Reset all selections
  resetSelections: () => void;
}

export const useTableListStore = create<TableListState>((set) => ({
  selectedFileId: null,
  selectedFileName: null,
  selectedFolderId: null,
  selectedFolder: null,
  selectedFolderName: null,
  selectedFile: null,
  
  setSelectedFileId: (id) => set({ selectedFileId: id }),
  setSelectedFileName: (name) => set({ selectedFileName: name }),
  setSelectedFolderId: (id) => set({ selectedFolderId: id }),
  setSelectedFolder: (folder) => set({ selectedFolder: folder }),
  setSelectedFolderName: (name) => set({ selectedFolderName: name }),
  setSelectedFile: (file) => set({ selectedFile: file }),
  
  resetSelections: () => set({
    selectedFileId: null,
    selectedFileName: null,
    selectedFolderId: null,
    selectedFolder: null,
    selectedFolderName: null,
    selectedFile: null,
  }),
}));
